import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import ResponsiveDrawer from '../Drawer/drawer';
import Toolbar from '@mui/material/Toolbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/GetApp';
import { useNavigate } from 'react-router-dom';
import { generateOrderPDF } from './PDFGenerator';

const TestPDF = () => {
    const drawerWidth = 240;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const generateTestPDF = async () => {
        setLoading(true);

        try {
            // Draw a mock white signature on a #4DB6AC teal background using a temporary offscreen canvas
            const canvas = document.createElement('canvas');
            canvas.width = 400;
            canvas.height = 160;
            const ctx = canvas.getContext('2d');

            // Fill background with teal
            ctx.fillStyle = '#4DB6AC';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw a nice signature curve
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 5;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            ctx.beginPath();
            ctx.moveTo(40, 90);
            ctx.bezierCurveTo(90, 30, 140, 130, 190, 80);
            ctx.bezierCurveTo(240, 30, 290, 130, 360, 70);
            ctx.stroke();

            const mockSignatureBase64 = canvas.toDataURL("image/png");

            // Mock draft object mirroring the real checkout draft
            const mockDraft = {
                selectedCustomer: {
                    StoreName: "14TH AVENUE SHOES",
                    customerid: "2052",
                    firstname: "AKIVA",
                    lastname: "BITTMAN",
                    email_1: "shoes4311@gmail.com",
                    email_2: "",
                    cell_1: "7188128972"
                },
                cartItems: [
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoe.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 19, unitQuantity: 2, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 22, unitQuantity: 2, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 23, unitQuantity: 2, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 24, unitQuantity: 2, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 25, unitQuantity: 2, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 26, unitQuantity: 12, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 27, unitQuantity: 19, unitFinalPrice: 50.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 28, unitQuantity: 3, unitFinalPrice: 51.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 29, unitQuantity: 3, unitFinalPrice: 51.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 30, unitQuantity: 3, unitFinalPrice: 51.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 34, unitQuantity: 9, unitFinalPrice: 52.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 36, unitQuantity: 11, unitFinalPrice: 52.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 37, unitQuantity: 11, unitFinalPrice: 52.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 38, unitQuantity: 15, unitFinalPrice: 52.75 },
                    { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 39, unitQuantity: 15, unitFinalPrice: 52.75 }
                ],
                shippingDetails: {
                    paymentTerm: "CREDIT CARD",
                    startDate: "18-06-2026",
                    cancelDate: "18-07-2026",
                    shippingAddress: {
                        storeName: "14TH AVENUE SHOES",
                        address1: "4311 14TH AVENUE",
                        address2: "BROOKLYN, NY, 11219",
                        city: "BROOKLYN",
                        state: "NY",
                        postcode: "11219",
                        country: "USA"
                    },
                    billingAddress: {
                        address1: "",
                        address2: "",
                        city: "",
                        state: "",
                        postcode: "",
                        country: ""
                    }
                },
                signature: mockSignatureBase64
            };

            const orderNumber = "986293";
            const orderDateStr = new Date().toISOString().split('T')[0];

            // Generate and download PDF
            const doc = await generateOrderPDF(mockDraft, orderNumber, orderDateStr);
            doc.save(`order_${orderNumber}_test.pdf`);

        } catch (error) {
            console.error("Test PDF generation failed:", error);
            alert("Failed to generate test PDF. Please check console for errors.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Test PDF Generator" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                    p: 4
                }}
                component="main"
            >
                <Toolbar />

                <Paper
                    sx={{
                        p: 5,
                        maxWidth: 500,
                        width: '100%',
                        textAlign: 'center',
                        borderRadius: 3,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.06)'
                    }}
                >
                    <Typography variant="h5" fontWeight="bold" gutterBottom color="primary">
                        PDF Layout Test Sandbox
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
                        Use this sandbox to trigger the order PDF generation using static mock data (matching PO# 986293, 14th Avenue Shoes, and product images). This eliminates having to create a new checkout flow order every time you want to verify visual styling.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<VisibilityIcon />}
                            onClick={() => navigate('/PreviewPDF')}
                            sx={{
                                fontWeight: 'bold',
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                boxShadow: 3
                            }}
                        >
                            Live PDF Preview
                        </Button>

                        <Button
                            variant="outlined"
                            color="success"
                            size="large"
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DownloadIcon />}
                            onClick={generateTestPDF}
                            disabled={loading}
                            sx={{
                                fontWeight: 'bold',
                                px: 4,
                                py: 1.5,
                                borderRadius: 2
                            }}
                        >
                            {loading ? "Generating..." : "Download Test PDF"}
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </div>
    );
};

export default TestPDF;
